import { ALL_OPTION } from '../constants/index.js';
import type { AllOption } from '../types/index.js';

export function isAllOption<Option>(
  option: Option | AllOption,
): option is AllOption {
  return option === ALL_OPTION;
}

// TODO: use (await asset.api.hasFeature('isMaxFeeAsset')) instead:
const isMaxFeeAsset = (assetName) => assetName === 'ethereum';

export const getFeeLabel = ({
  assetName,
  isMax,
  isEstimated,
  displayNetworkName,
}: {
  assetName: string;
  isMax: boolean;
  isEstimated?: any;
  displayNetworkName: string;
}) => {
  if (isMax) {
    return 'Max Network Fee';
  }

  return isMaxFeeAsset(assetName) || isEstimated
    ? 'Network Fee'
    : `${displayNetworkName ? `${displayNetworkName} ` : ''}Network Fee`;
};

export const FEE_LINK =
  'https://www.exodus.com/support/article/68-does-exodus-have-fees-to-send-or-receive#';

export const getFeeLink = ({ isMax } = {} as { isMax: boolean }) =>
  isMax ? `${FEE_LINK}max` : `${FEE_LINK}estimated`;

// NaN is excluded from return type since its type is `number` which would result in `never`
export const isNonNumber = (
  value: number | null | undefined,
): value is null | undefined => {
  return value === undefined || value === null || Number.isNaN(value);
};
